import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
  stepOne(filter: $filter) {
    productVersions {
        id
        name
        description
        application
        image_path
        comparison_image_path
        max_power
        min_power
        mn_label
        is_default
        configurator_name
        configurator_comparison_name
        configurator_group_name
        configurator_order_no
        configurator_tooltip
        configurator_comparison_tooltip
        is_pre_selected
        pre_selected_by_user
        ip_rating
        ik_rating
        power_temperature {
            max_power
            max_temperature
            min_temperature
        }
    }

    product {
        beeProductId
        productName
        productDescription
        productApprovals
        bodyMaterial
        coverMaterial
        opticMaterial
        ipRating
        ikRating
        powerTemperature {
            max_power
            max_temperature
            min_temperature
        }
    }

    echoVersionName
    standardVersionName
    mountings {
        id
        name
        mn_label
        pre_selected_by_user
        file_path
        ip_rating
        ik_rating
    }
  }
}`;